import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'wlm-section-wrapper',
    templateUrl: './section-wrapper.component.html',
    styleUrls: ['./section-wrapper.component.scss'],
    standalone: false
})
export class SectionWrapperComponent extends FieldWrapper {}
